import gql from 'graphql-tag';

export default gql(`
	query employees_filtered( $name: String, $company_guid: [ String ], $department_guid: [ String ], $team_guid : [ String ], $jobtitle_guid: [ String ] )  {
		employees_filtered( name: $name, company_guid: $company_guid, department_guid: $department_guid, team_guid: $team_guid, jobtitle_guid: $jobtitle_guid ) {
			guid
			name
		}
	}
`);
